import { Redirect, useActivePageRegistration } from "@hex-insights/router";
import { preferencesStudentDataConsentsPageInfo } from "../StudentDataConsents/pageinfo";
import { preferencesIndexPageInfo } from "./pageinfo";

export function PreferencesIndexPage() {
	useActivePageRegistration(preferencesIndexPageInfo);

	return <Redirect to={preferencesStudentDataConsentsPageInfo.to} />;
}
